import React from "react";
import Column from "@amzn/meridian/column";
import Row from "@amzn/meridian/row";
import FAQ from "../desktop/FAQ";
import {
  AllegroIsHereNonDesktop,
  HeresHowItWorksNonDesktop,
  FooterMobile,
} from "../../../shared";
// @ts-ignore
import img from "../../../shared/images/desktop/BackgroundImage.png";
import "./homeMobile.css";
import "./test.css";
import Video from "../../../shared/components/video";
import useLocaleContext from "src/components/shared/context/useLocaleContext";
import { getVideoSourceByLanguage } from "src/components/shared/utils/utils";

const HomeMobile = () => {
  const { language } = useLocaleContext();
  const videoSource = getVideoSourceByLanguage(language);

  const styles = {
    backgroundTablet: {
      backgroundImage: `url(${img})`,
      backgroundPosition: "top right",
      backgroundRepeat: "no-repeat",
      backgroundSize: "auto 650px",
    },
  };

  return (
    <div
      id="homeMobile"
      style={styles.backgroundTablet}
      className="backgroundMobileTest backgroundMobile"
    >
      <Column
        spacing="none"
        heights={["3em", "fill", "4em", "fill", "5em"]}
        alignmentHorizontal="start"
      >
        <Row></Row>
        <Row widths={["grid-1", "grid-10"]}>
          <Column></Column>
          <Column spacing="600" spacingInset="none">
            <AllegroIsHereNonDesktop></AllegroIsHereNonDesktop>
            <Video widthRatio={0.9} src={videoSource}></Video>
            <HeresHowItWorksNonDesktop></HeresHowItWorksNonDesktop>
          </Column>
        </Row>
        <Row></Row>
        <FAQ></FAQ>
        <FooterMobile></FooterMobile>
      </Column>
    </div>
  );
};

export default HomeMobile;
